// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* To override rsuite lib (rsuite/dist/styles/rsuite-dark.css) margin , Remove changes after removal of rsuite lib dependency */
p {
  margin: unset;
}

p + p {
  margin-top: unset;
}
`, "",{"version":3,"sources":["webpack://./src/features/operations/routes/LEA.new/styles/styles.css"],"names":[],"mappings":"AAAA,+HAA+H;AAC/H;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* To override rsuite lib (rsuite/dist/styles/rsuite-dark.css) margin , Remove changes after removal of rsuite lib dependency */\np {\n  margin: unset;\n}\n\np + p {\n  margin-top: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
